import angular from 'angular';

import { BaseFileUpload } from 'app/common/files.upload';


class PlantFileUpload extends BaseFileUpload {

    constructor ($cookies, TokenService, Upload, Company) {
        super($cookies, TokenService, Upload);
        this.company = Company;
    }

    uploadFile (file) {
        if (!file) {
            return ;
        }
        let uri = this.company.getRequestedUrl();
        let data = {
            signature: file,
        };
        return super.uploadFile(uri, data, file.type, 'patch');
    }
}


export default class EditPlantCtrl {
    constructor ($uibModalInstance, $cookies, TokenService, R, company, Upload) {
        "ngInject";
        this.R = R;
        this.data = this.R.copy(company);
        this.company = company;
        this.$modal = $uibModalInstance;
        this.data.mapping = [];
        this.fileUpload = new PlantFileUpload($cookies, TokenService, Upload, company);
    }

    get title () {
        return `Edit plant`;
    }

    close () {
        this.$modal.dismiss();
    }

    upload (file) {
        let self = this;
        this.fileUpload.uploadFile(file, {signature: file}).then((response) => {
            angular.extend(self.company, response.data);
        })
    }

    submit () {
        let self = this;
        // Always delete signature form PUT request
        delete this.data.signature;
        this.data.put().then(
            data => {
                angular.extend(self.company, data);
                self.$modal.close(data);
            },
            resp => { self.errors = resp.data; },
        ).finally(() => self.loading = false);
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/plants/ctrls.js